// Searchanise 헤더 검색 클릭 시 서치 패널이 함께 열리도록 보정하는 커스텀 스크립트
// Eurus 테마에서 기본 검색 패널 자동 오픈이 동작하지 않아 앱 기능을 이용하여 suggestion 5개 이상일 때 강제 트리거 처리되도록 함

document.addEventListener('Searchanise.Loaded', function() {
    (function($) {
        if (Searchanise?.GetWidgets()?.options?.AutocompleteSuggestOnSearchBoxEmpty === 'Y'
            && Searchanise?.preloadedSuggestions?.length >= 5) {
            $('.header-search-pill, .header-search-trigger-mobile').on('click', function() {
                let input = $('#FormSearch .snize-input-style');
                if (!$('.snize-ac-results-mobile').length) {
                    Searchanise.AutocompleteCloseAll();
                    let x = input.val();
                    setTimeout(function() {
                        input.val(x);
                        input.trigger('click');
                    },400);
                } else {
                    input = $('#snize-mobile-search-input');
                    if ($('#snize-instant-search-results').length > 1) {
                        Searchanise.AutocompleteUpdateCloseAll();
                        $('.header__mobile-search-trigger').click();
                    }
                    let x = input.val();
                    input.val('');
                    setTimeout(()=>input.val(x),400);
                }
            });
        }
    })(window.Searchanise.$);
});
